export default {"src":"/_next/static/media/image_help_customers_2.3169936a.svg","height":260,"width":1222,"blurWidth":0,"blurHeight":0};